// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"10b5c85f","83":"5ebe6a2d","274":"6e1df326","365":"a80cc039","436":"66a899d6","871":"51f76f24","932":"9abd2af7"}[chunkId] + ".js";
};